export const DECISION_FOLDER_ADD = 'FOLDERS_DECISION_FOLDER_ADD';
export const DECISION_FOLDER_REMOVE = 'FOLDERS_DECISION_FOLDER_REMOVE';
export const DECISION_FOLDERS_SET = 'FOLDERS_DECISION_FOLDERS_SET';
export const DECISIONS_FOLDERS_SET = 'FOLDERS_DECISIONS_FOLDERS_SET';

export const FOLDERS_SET = 'FOLDERS_FOLDERS_SET';

export const FOLDER_LOAD_DECISIONS = 'FOLDERS_FOLDER_LOAD_DECISIONS';
export const FOLDER_ERROR_DECISIONS = 'FOLDERS_FOLDER_ERROR_DECISIONS';
export const FOLDER_GET_DECISIONS = 'FOLDERS_FOLDER_GET_DECISIONS';

export const FOLDER_LOAD_ANNOTATIONS = 'FOLDERS_FOLDER_LOAD_ANNOTATIONS';
export const FOLDER_ERROR_ANNOTATIONS = 'FOLDERS_FOLDER_ERROR_ANNOTATIONS';
export const FOLDER_GET_ANNOTATIONS = 'FOLDERS_FOLDER_GET_ANNOTATIONS';

export const FOLDER_CREATED = 'FOLDERS_FOLDER_CREATED';
export const FOLDER_DELETED = 'FOLDERS_FOLDER_DELETED';
export const FOLDER_RENAMED = 'FOLDERS_FOLDER_RENAMED';
export const FOLDER_CREATE_ERROR_ALREADY_CREATED =
  'FOLDER_CREATE_ERROR_ALREADY_CREATED';
export const FOLDER_DECISION_DELETED = 'FOLDER_DECISION_DELETED';

export const FOLDER_ANNOTATION_CHANGED = 'FOLDER_ANNOTATION_CHANGED';

export const MULTIPLE_DECISION_FOLDER_ADD = 'MULTIPLE_DECISION_FOLDER_ADD';
export const MULTIPLE_DECISION_FOLDER_REMOVE =
  'MULTIPLE_DECISION_FOLDER_REMOVE';
